export default __webpack_public_path__ + "static/media/background-letter-1.49355088.png";